export enum RelatedView {
  'PATIENT' = 'PATIENT',
  'CONTACT' = 'CONTACT',
  'FILTERED' = 'FILTERED',
}
